import ProductViewControlController from './view-control';

export default class ScansScanProductConversationsController extends ProductViewControlController {}
